"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartProgressRing = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const style_map_js_1 = require("lit/directives/style-map.js");
require("@/components/common/text/text");
/**
 * 진행률을 원 둘레로 채우고 가운데에 퍼센트를 적는 고리.
 * 읽히는 진행률은 곁에 둔 네이티브 progress가 맡으므로 보조 기술에는 드러내지 않는다.
 */
let ChartProgressRing = class ChartProgressRing extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        /** 0–100 사이 퍼센트 */
        this.value = 0;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return (0, lit_1.html) `
      <svg viewBox="0 0 36 36">
        ${(0, lit_1.svg) `
          <circle class="track" cx="18" cy="18" r="15.9155"></circle>
          <circle
            class="value"
            cx="18"
            cy="18"
            r="15.9155"
            style=${(0, style_map_js_1.styleMap)({ strokeDashoffset: `${100 - this.value}` })}
          ></circle>
        `}
      </svg>
      <mm-text>${this.value}%</mm-text>
    `;
    }
};
ChartProgressRing.styles = (0, lit_1.css) `
    :host {
      display: grid;
      flex-shrink: 0;
      place-items: center;
      width: var(--size-80);
      height: var(--size-80);
    }

    svg,
    mm-text {
      grid-area: 1 / 1;
    }

    svg {
      width: 100%;
      height: 100%;
    }

    circle {
      fill: none;
      stroke-width: 3;
      transform: rotate(-90deg);
      transform-origin: center;
    }

    .track {
      stroke: var(--background-subtle-color);
    }

    /* r을 100/2π로 잡아 둘레가 100이므로 offset에 퍼센트를 그대로 뺀다. */
    .value {
      stroke: var(--primary-color);
      stroke-linecap: round;
      stroke-dasharray: 100;
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Number })
], ChartProgressRing.prototype, "value", void 0);
ChartProgressRing = __decorate([
    (0, decorators_js_1.customElement)('mm-chart-progress-ring')
], ChartProgressRing);
exports.ChartProgressRing = ChartProgressRing;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhcnQtcHJvZ3Jlc3MtcmluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNoYXJ0LXByb2dyZXNzLXJpbmcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQWdEO0FBQ2hELHFEQUEyRDtBQUMzRCw4REFBc0Q7QUFFdEQseUNBQXNDO0FBRXRDOzs7R0FHRztBQUVJLElBQU0saUJBQWlCLEdBQXZCLE1BQU0saUJBQWtCLFNBQVEsZ0JBQVU7SUFBMUM7O1FBc0NMLG1CQUFtQjtRQUNTLFVBQUssR0FBRyxDQUFDLENBQUE7SUF3QnZDLENBQUM7SUF0QkMsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxhQUFhLEVBQUUsTUFBTSxDQUFDLENBQUE7SUFDMUMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOztVQUVMLElBQUEsU0FBRyxFQUFBOzs7Ozs7O29CQU9PLElBQUEsdUJBQVEsRUFBQyxFQUFFLGdCQUFnQixFQUFFLEdBQUcsR0FBRyxHQUFHLElBQUksQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDOztTQUVoRTs7aUJBRVEsSUFBSSxDQUFDLEtBQUs7S0FDdEIsQ0FBQTtJQUNILENBQUM7O0FBN0RNLHdCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW9DbEIsQ0FBQTtBQUUyQjtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7Z0RBQVU7QUF2QzFCLGlCQUFpQjtJQUQ3QixJQUFBLDZCQUFhLEVBQUMsd0JBQXdCLENBQUM7R0FDM0IsaUJBQWlCLENBK0Q3QjtBQS9EWSw4Q0FBaUIifQ==